const SMART_CAPTCHA_LOAD_TIMEOUT_MS = 20000

let loadPromise = null
function loadScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js'
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.smartCaptcha)
    script.onerror = (error) => {
      loadPromise = null
      reject(error)
    }
    document.head.appendChild(script)
  })
}

export default (_context, inject) => {
  const loadSmartCaptcha = () => {
    if (typeof window === 'undefined') return Promise.resolve(null)
    if (window.smartCaptcha) return Promise.resolve(window.smartCaptcha)
    if (loadPromise) return loadPromise

    loadPromise = new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        loadPromise = null
        reject(new Error('SmartCaptcha load timeout'))
      }, SMART_CAPTCHA_LOAD_TIMEOUT_MS)

      loadScript()
        .then((smartCaptcha) => {
          clearTimeout(timeoutId)
          resolve(smartCaptcha)
        })
        .catch((error) => {
          clearTimeout(timeoutId)
          reject(error)
        })
    })

    return loadPromise
  }

  inject('loadSmartCaptcha', loadSmartCaptcha)
}
